import { render, staticRenderFns } from "./OfficialProcessingIcon.vue?vue&type=template&id=a7320e62&scoped=true"
import script from "./OfficialProcessingIcon.vue?vue&type=script&lang=js"
export * from "./OfficialProcessingIcon.vue?vue&type=script&lang=js"
import style0 from "./OfficialProcessingIcon.vue?vue&type=style&index=0&id=a7320e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7320e62",
  null
  
)

export default component.exports